/*
 * @Author: yezs 
 * @Date: 2022-04-20 14:12:52 
 * @Last Modified by: yezs
 * @Last Modified time: 2022-04-20 15:52:38
 */
<template>
  <div class="container">
    <div class="details-top">
      <div>
        <img src="@/assets/imgs/floor.png" alt="" />
        <span>{{ shiftDetails.FloorNames }}</span>
      </div>
      <div>
        <img src="@/assets/imgs/date.png" alt="" />
        <span>{{ shiftDetails.CDate | dateFormat('yyyy-mm-dd')}}</span>
      </div>
    </div>
    <div class="details-content">
      <div class="midday" v-if="shiftDetails.Morning.ElderlyTotal">
        <div class="midday-title"> 
          <div class="midday-left">
            <img src="@/assets/imgs/morning.png" alt="" />
            <span>早班</span>
            <p>录入人:{{ shiftDetails.Morning.CUser }}</p>
          </div>
          <span class="midday-right"
            >总人数:{{ shiftDetails.Morning.ElderlyTotal }}</span
          >
        </div>
        <div class="midday-num">
          <div class="num-item" v-if="shiftDetails.Morning.NewAdmission">
            <span>新入住 </span>
            <p>{{ shiftDetails.Morning.NewAdmission }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Morning.Withdraw">
            <span>退住 </span>
            <p>{{ shiftDetails.Morning.Withdraw }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Morning.GoOut">
            <span>外出 </span>
            <p>{{ shiftDetails.Morning.GoOut }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Morning.Die">
            <span>离世 </span>
            <p>{{ shiftDetails.Morning.Die }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Morning.QuarantinePeople">
            <span>隔离人数 </span>
            <p>{{ shiftDetails.Morning.QuarantinePeople }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Morning.Hospitalized">
            <span>住院 </span>
            <p>{{ shiftDetails.Morning.Hospitalized }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Morning.Departure">
            <span>120送院 </span>
            <p>{{ shiftDetails.Morning.Departure }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Morning.Actual">
            <span>实际人数 </span>
            <p>{{ shiftDetails.Morning.Actual }}</p>
          </div>
        </div>
        <div class="details-digest">
          <div
            class="digest-item"
            v-for="item in shiftDetails.Morning.ShiftModels"
          >
            <div class="digest-top">
              <div>
                <span>房号：</span>
                <p>{{ item.RoomNo }}</p>
              </div>
              <div>
                <span>姓名：</span>
                <p>{{ item.PName }}</p>
              </div>
            </div>
            <div class="digest-bottom">
              <span>病情摘要：</span>
              <p>{{ item.Note }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="midday" v-if="shiftDetails.Middle.ElderlyTotal">
        <div class="midday-title">
          <div class="midday-left">
            <img src="@/assets/imgs/middle.png" alt="" />
            <span>中班</span>
            <p>录入人:{{ shiftDetails.Middle.CUser }}</p>
          </div>
          <span class="midday-right"
            >总人数:{{ shiftDetails.Middle.ElderlyTotal }}</span
          >
        </div>
        <div class="midday-num">
          <div class="num-item" v-if="shiftDetails.Middle.NewAdmission">
            <span>新入住 </span>
            <p>{{ shiftDetails.Middle.NewAdmission }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Middle.Withdraw">
            <span>退住 </span>
            <p>{{ shiftDetails.Middle.Withdraw }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Middle.GoOut">
            <span>外出 </span>
            <p>{{ shiftDetails.Middle.GoOut }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Middle.Die">
            <span>离世 </span>
            <p>{{ shiftDetails.Middle.Die }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Middle.QuarantinePeople">
            <span>隔离人数 </span>
            <p>{{ shiftDetails.Middle.QuarantinePeople }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Middle.Hospitalized">
            <span>住院 </span>
            <p>{{ shiftDetails.Middle.Hospitalized }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Middle.Departure">
            <span>120送院 </span>
            <p>{{ shiftDetails.Middle.Departure }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Middle.Actual">
            <span>实际人数 </span>
            <p>{{ shiftDetails.Middle.Actual }}</p>
          </div>
        </div>
        <div class="details-digest">
          <div
            class="digest-item"
            v-for="item in shiftDetails.Middle.ShiftModels"
          >
            <div class="digest-top">
              <div>
                <span>房号：</span>
                <p>{{ item.RoomNo }}</p>
              </div>
              <div>
                <span>姓名：</span>
                <p>{{ item.PName }}</p>
              </div>
            </div>
            <div class="digest-bottom">
              <span>病情摘要：</span>
              <p>{{ item.Note }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="midday" v-if="shiftDetails.Night.ElderlyTotal">
        <div class="midday-title">
          <div class="midday-left">
            <img src="@/assets/imgs/night.png" alt="" />
            <span>晚班</span>
            <p>录入人:{{ shiftDetails.Night.CUser }}</p>
          </div>
          <span class="midday-right"
            >总人数:{{ shiftDetails.Night.ElderlyTotal }}</span
          >
        </div>
        <div class="midday-num">
          <div class="num-item" v-if="shiftDetails.Night.NewAdmission">
            <span>新入住 </span>
            <p>{{ shiftDetails.Night.NewAdmission }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Night.Withdraw">
            <span>退住 </span>
            <p>{{ shiftDetails.Night.Withdraw }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Night.GoOut">
            <span>外出 </span>
            <p>{{ shiftDetails.Night.GoOut }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Night.Die">
            <span>离世 </span>
            <p>{{ shiftDetails.Night.Die }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Night.QuarantinePeople">
            <span>隔离人数 </span>
            <p>{{ shiftDetails.Night.QuarantinePeople }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Night.Hospitalized">
            <span>住院 </span>
            <p>{{ shiftDetails.Night.Hospitalized }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Night.Departure">
            <span>120送院 </span>
            <p>{{ shiftDetails.Night.Departure }}</p>
          </div>
          <div class="num-item" v-if="shiftDetails.Night.Actual">
            <span>实际人数 </span>
            <p>{{ shiftDetails.Night.Actual }}</p>
          </div>
        </div>
        <div class="details-digest">
          <div
            class="digest-item"
            v-for="item in shiftDetails.Night.ShiftModels"
          >
            <div class="digest-top">
              <div>
                <span>房号：</span>
                <p>{{ item.RoomNo }}</p>
              </div>
              <div>
                <span>姓名：</span>
                <p>{{ item.PName }}</p>
              </div>
            </div>
            <div class="digest-bottom">
              <span>病情摘要：</span>
              <p>{{ item.Note }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      shiftDetails: JSON.parse(localStorage.getItem("item")),
    };
  },
  // 计算属性
  computed: {},
  filters: {
    dateFormat: function (dateStr, pattern = "") {
      var dt = new Date(dateStr);
      var yy = dt.getFullYear();
      var mm =
        dt.getMonth() + 1 < 10 ? "0" + (dt.getMonth() + 1) : dt.getMonth() + 1;
      var dd = dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate();
      var h = dt.getHours() < 10 ? "0" + dt.getHours() : dt.getHours();
      var m = dt.getMinutes() < 10 ? "0" + dt.getMinutes() : dt.getMinutes();
      var s = dt.getSeconds() < 10 ? "0" + dt.getSeconds() : dt.getSeconds();
      if (pattern.toLowerCase() === "yyyy-mm-dd") {
        return yy + "-" + mm + "-" + dd;
      } else {
        return yy + "-" + mm + "-" + dd + " " + h + ":" + m;
      }
    },
  },
  // 侦听器
  watch: {},

  // 组件方法
  methods: {},
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
   * 在实例初始化之后，组件属性计算之前，如data属性等
   */
  beforeCreate() {},
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {},
  /**
   * 在挂载开始之前被调用：相关的 render 函数首次被调用。
   */
  beforeMount() {},
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted() {},
  /**
   * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
   * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
   */
  beforeUpdate() {},
  /**
   * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
   * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
   */
  updated() {},
  /**
   * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
   */
  activated() {},
  /**
   * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
   */
  deactivated() {},
  /**
   * 实例销毁之前调用。在这一步，实例仍然完全可用。
   */
  beforeDestroy() {},
  /**
   * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
   * 所有的事件监听器会被移除，所有的子实例也会被销毁。
   */
  destroyed() {},
};
</script> 

<style scoped>
.details-top {
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding: 12px 23px;
  display: flex;
  flex-direction: column;
}
.details-top div {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}
.details-top div:last-child {
  margin-bottom: 0;
}
.details-top div img {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
.details-top div span {
  font-size: 16px;
  color: #029fd1;
  font-weight: bold;
}
.details-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px 15px;
  box-sizing: border-box;
}
.midday {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 4px;
  margin-bottom: 12px;
  box-sizing: border-box;
  padding: 12px;
}
.midday-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.midday-left {
  display: flex;
  align-items: center;
}
.midday-left img {
  width: 24px;
  height: 24px;
}
.midday-left span {
  font-size: 14px;
  color: #0a0e10;
  font-weight: bold;
  margin-left: 13px;
}
.midday-left p {
  color: #7c7e80;
  font-size: 12px;
  margin: 0;
  margin-left: 20px;
}
.midday-right {
  font-size: 14px;
  color: #029fd1;
  font-weight: bold;
}
.midday-num {
  background-color: #f7f8fa;
  border-radius: 6px;
  display: flex;
  flex-wrap: wrap;
}
.num-item {
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
  position: relative;
}
.num-item::after {
  position: absolute;
  content: "";
  width: 1px;
  height: 30px;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 0;
  background-color: #ebebeb;
}
.num-item:nth-child(4n) ::after {
  content: "";
  width: 0;
  height: 0;
}
.num-item span {
  font-size: 12px;
  color: #434649;
  margin-bottom: 6px;
}
.num-item p {
  margin: 0;
  font-size: 18px;
  color: #0a0e10;
  font-weight: bold;
}
.details-digest {
  display: flex;
  width: 100%;
  flex-direction: column;
}
.digest-item {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 12px 10px;
  border-bottom: 1px solid #ebebeb;
}
.digest-item:last-child {
  border-bottom: 0;
}
.digest-top {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.digest-top div {
  flex: 1;
  display: flex;
  align-items: center;
}
.digest-top span {
  font-size: 14px;
  color: #7c7e80;
}
.digest-item p {
  flex: 1;
  font-size: 14px;
  margin: 0;
  color: #0a0e10;
}
.digest-bottom {
  display: flex;
}
.digest-bottom span {
  font-size: 14px;
  color: #029fd1;
}
</style>



// WEBPACK FOOTER //
// src/components/shiftExchange/shiftExchangeDetails.vue